// extracted by mini-css-extract-plugin
export default {"enabledContainer":"src-pages-SalesChannelProductsConfig-SalesChannelProductContent-SEOSetting-css-module__enabledContainer--CNcnl"};